
import { Component, Vue } from 'vue-property-decorator'
import { apiAgentApplySubmit } from '../api'
@Component
export default class extends Vue {
  account = ''
  realname = ''
  idnumber = ''
  phone = ''
  aliAccount = ''

  get isWrite() {
    return (
      this.account &&
      this.realname &&
      this.idnumber &&
      this.phone &&
      this.aliAccount
    )
  }
  showPop = false
  isAgree = false
  loading = false
  validate() {
    if (!this.isWrite) {
      this.$toast('请填写完整信息')
      return false
    }
    //a.校验账号为数字和字母且小于等于10位  b. 姓名：限制输入 ≦ 10位 c. 身份证号：限制输入数字和字母且 = 18位d. 手机号：限制输入数字且 = 11位
    if (!/^[A-Za-z0-9]{1,10}$/.test(this.account)) {
      this.$toast('请输入正确的账号')
      return false
    }
    if (this.realname.length > 10) {
      this.$toast('请输入正确的姓名')
      return false
    }
    if (!/^[A-Za-z0-9]{18}$/.test(this.idnumber)) {
      this.$toast('请输入正确的身份证号')
      return false
    }
    if (!/^\d{11}$/.test(this.phone)) {
      this.$toast('请输入正确的手机号')
      return false
    }
    return true
  }
  async handleSubmit() {
    const flag = this.validate()
    console.log('flag', flag)
    if (!flag) {
      return
    }
    const remoteCheck = await apiAgentApplySubmit({
      userNumber: this.account,
      type: 1,
      realName: this.realname,
      mobile: this.phone,
      alipayAccount: this.aliAccount,
      certNo: this.idnumber
    })
    console.log('remoteCheck', remoteCheck)
    if (flag) {
      this.showPop = true
    }
  }

  async doSubmit() {
    if (!this.isAgree) {
      this.$toast('请勾选同意后再提交')
      return
    }
    if (this.loading) {
      return
    }
    this.loading = true
    setTimeout(() => {
      this.loading = false
    }, 2000)
    //todo
    const { data } = await apiAgentApplySubmit({
      userNumber: this.account,
      type: 2,
      realName: this.realname,
      mobile: this.phone,
      alipayAccount: this.aliAccount,
      certNo: this.idnumber
    })
    if (data) {
      this.$toast('提交成功')
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    }
  }
}
